<template>
  <div class="line-chart">
    <div v-if="skinType > 0">
      <vuedraggable :distanceRight="distanceRight" :distanceBottom="distanceBottom" :isScrollHidden="false"
        :isCanDraggable="true" :zIndex="998">
        <div class="mar-bot20" @click="handleShowOpen">
          <canvas v-if="skinType === 1" id="bollCanvas" width="128px" height="128px"></canvas>
          <div v-else-if="skinType === 2" style="position: relative;">
            <img class="usdt-icon" src="./img/usdt.gif" alt="" />
            <div v-if="percentComplete > 0" class="progress" :style="{ width: 110 * percentComplete / 100 + 'px' }"></div>
            <div class='progress-text' :class="status == 0 && 'progress-text-finish'">
              {{ status == 0 ? "领取" + rewardAmount + "元" : percentComplete + "%" }}</div>

          </div>
        </div>
      </vuedraggable>
    </div>
    <el-dialog :visible.sync="dialogVisible" center :show-close="false">
      <img class="usdt-img-head" v-if="skinType === 2" src="./img/usdt_head.png" alt="" />
      <div class="step">
        <div class="step-header">
          <div class="title-bg"></div>
          <div class="img-box">
            <img v-show="showDetail" @click="handleBackStep" class="back-btn" src="./img/back.png" alt="" />
          </div>
          <div class="title-text">{{ showDetail ? '任务详情' : '神秘任务将来' }}</div>
        </div>
        <div class="line"></div>
        <div class="step-list" v-if="!showDetail">
          <div class="step-item" v-for="(award, index) in totalAward" :key="award.award + index">
            <step1 :percentage="award.percentage" :curValue="award.curValue" :maxValue="award.rounds"
              :skin-type="skinType" :activityType="award.activityType"
              @handleSetp="() => handleSetp(award.status, award)">
              <div slot="right" class="btn" @click="handleSetp(award.status, award)">
                {{ award.status === 0 ? '可领取' : award.status === 1 ? ' 已领取' : '详情' }}
              </div>
            </step1>
          </div>
        </div>
        <!--详情-->
        <div class="img-list" v-if="showDetail">
          <div v-html="intro"></div>
        </div>
      </div>
      <img class="close" src="./img/close.png" @click="handleClose">
      <div class="received" v-if="receivedSuccess">
        <img class="img-success" src="./img/success.png" mode="" />
        <div class="text-success">领取成功</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vuedraggable from "vue-draggable-float";
import step from "./step.vue";
import step1 from "./step1.vue"
export default {
  components: {
    vuedraggable,
    step,
    step1
  },
  data() {
    return {
      bollStep: null,
      bollTimeR: null,
      first: 1,
      receivedSuccess: false, //  显示领取成功页面
      showDetail: false, //  显示详情
      stepText: this.$t("完成"),
      status: 1, //未完成
      list: [],
      index: 0,
      percentComplete: 0, // 进度条
      rewardAmount: 0, // 领取总金额
      intro: "", // 富文本
      totalAward: [],
      thematicActivitiesId: "",
      isShowBar: false,
      distanceRight: 1750,
      distanceBottom: 300,
      dialogVisible: false,
      bubble: require('./img/bubble.png'),
      bubbleImg: null,
      skinType: 0,//皮肤类型 0：不显示,1:水球,2:usdt
    };
  },
  watch: {
    "$store.state.token"(n) {
      if (n) {
        this.getWaterBallList();
      } else {
        this.isShowBar = false
      }
    },
  },
  beforeDestroy() {
    cancelAnimationFrame(this.bollTimeR);
  },
  mounted() {
    this.distanceRight = window.innerWidth - 150

    const image = new Image();

    image.onload = function () {
      this.bubbleImg = image;
    }.bind(this);
    image.src = this.bubble;

    if (this.$common.getUser()) {

      this.getWaterBallList()
    }

  },
  methods: {
    async getWaterBallList() {
      let childCode = window.childCode;
      const res = await this.$http.get(this.$api.getWaterBallList, childCode);
      console.log("getWaterBallList", res)
      if (res && res.data.length > 0) {
        const data = res?.data
        const sbwList = data.find(item => item.name === '水球活动' && item.status === 0)
        let {
          intro,
          speActBigWheelVO,
          id,
          skinType
        } = sbwList || {}
        let {
          totalSpinCount, //总投注金额
          //totalDeposit, // 总存款金额
          totalAward, //奖励状态数据
          totalSpinAwardConf, //活动配置
        } = speActBigWheelVO || {}
        this.thematicActivitiesId = id
        this.intro = intro
        let list = [];

        console.log("totalAward=============",totalAward)
        for (var i = 0; i < totalAward.length; i++) {
          let item = totalAward[i];

          //1:已领取 0:未领取 -1:失效-2 未满足,过滤出未领取和未满足的活动
          if (item.status === -2 || item.status === 0) {
            let config = totalSpinAwardConf[i];
            let curValue = 0;
            if (config.type === 3) {
              // curValue =totalDeposit
              curValue = totalAward[i].countDeposit;
            } else {
              curValue = totalSpinCount;
            }

            //  未完成
            if (item.status == 0) {
              item.percentage = 100;
            } else {
              item.percentage = Math.min(100, Math.floor((curValue / item
                .rounds) * 100));
            }

            if (list.length === 0) {
              this.percentComplete = item.percentage; // 取第一个的进度
              if (config.awardMoneyType === 2) { //比例金额
                this.rewardAmount = Math.min(item.awardMax, Math.floor(item.rounds * item
                  .awardValue / 100));
              } else {
                this.rewardAmount = item.award;
              }
            }

            item.curValue = curValue;
            item.activityType = config.type;

            list.push(item);
          }
        }
        this.totalAward = list
        console.log("totalAward", this.totalAward);
        if (this.totalAward && this.totalAward.length > 0) {
          this.skinType = skinType;
          if (!skinType) {
            this.skinType = 1
          }
          setTimeout(() => {
            this.drawBollWave();
          }, 10)

        } else {
          this.skinType = 0
          this.dialogVisible = false
        }
      }
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 返回进度列表
    handleBackStep() {
      this.showDetail = false;
    },
    // 点击领取或详情、进度条进入详情明细
    handleSetp(status, item) {
      // 根据状态显示成功弹窗
      if (status === 0) {
        this.$http
          .put(
            this.$api.getSbwReceive + this.thematicActivitiesId + "&betNo=" + encodeURIComponent(item.rounds)
          )
          .then((res) => {
            if (res.code == 0) {
              this.receivedSuccess = true;
              setTimeout(() => {
                this.receivedSuccess = false;
                this.getWaterBallList();
              }, 3000)
            } else {
              this.$message.error(this.$t("errorCode." + res.code));
            }
          });
      } else {
        this.showDetail = true;
      }
      // _paq.push(["trackEvent", "Pc_receiveWaterActivity", "Pc_receiveWaterActivity", '水球领取', 1]);
    },
    handleShowOpen() {
      this.dialogVisible = true;
      // _paq.push(["trackEvent", "Pc_clickWaterActivity", "Pc_clickWaterActivity", '点击水球活动', 1]);
    },
    toFixedNumber(n = 2, val) {
      //去小数点后2位
      if (typeof val == "number") {
        return val.toFixed(n) * 1;
      }
    },
    //绘制原型水球
    drawBollWave(ids, elem) {

      let _this = this;
      let canvas = document.getElementById("bollCanvas");
      let ctx = canvas.getContext("2d"),
        w = 128,
        h = 128,
        grd = null, //渐变色grd
        grds = null,
        angle = 0,
        x = 0,
        y = 0,
        y2 = 0,
        part = 0; //part声波初始位置
      let grid = {
        top: (5 * h) / 100, //水球距离顶的 15%
      };
      let bollArg = {
        R: h / 2 - grid.top, //圆半径
        O: {
          x: w / 2,
          y: h / 2,
        }, //圆心坐标 x, y
        A: 1, //振幅
        vs: 10, //声波运动速度 越大值 越慢
        lineWidth: 1,
        waveOpacity: 1, //水波的透明度
        waveHeight: _this.percentComplete, // 80百分之80%（占整个水球的百分比高度）
        angleStep: 5, //声波上圆点间隔的距离
        waveLen: 30, //波长
        waveStyle: {
          fillColor: {
            start: "rgba(137, 184, 255, 0.4)",
            end: "rgba(188, 219, 255, 0.8)"
          },
          strokeColor: "#ffffff"
        }, //波浪颜色样式
        oStyle: {
          fillColorStart: "rgba(242, 232, 217, 0)",
          fillColorEnd: "rgba(192, 139, 67, 0)",
          strokeColor: "rgba(255, 255, 255, 0)"
        }, //圆的颜色样式
        textStyle: {
          fillColor: "#0D1431",
          fontSize: 26
        },
      };
      ctx.clearRect(0, 0, w, h);

      let drawBoll = () => {
        if (!this.bubbleImg) {
          this.bollTimeR = requestAnimationFrame(drawBoll);
          return;
        }
        ctx.clearRect(0, 0, w, h);
        ctx.save();

        //背景图
        ctx.drawImage(this.bubbleImg, 4, 4, w - 6, h - 6);

        ctx.beginPath();
        ctx.lineWidth = bollArg.lineWidth;

        // 设置描边颜色
        ctx.strokeStyle = bollArg.oStyle.strokeColor;


        // 设置填充色
        let grds = ctx.createRadialGradient(bollArg.O.x, bollArg.O.y, bollArg.R, bollArg.O.x, bollArg.O.y, bollArg.R);
        grds.addColorStop(0, bollArg.oStyle.fillColorEnd); // 圆心颜色
        grds.addColorStop(1, bollArg.oStyle.fillColorStart); // 边缘颜色
        ctx.fillStyle = grds;

        ctx.arc(bollArg.O.x, bollArg.O.y, bollArg.R, 0, 2 * Math.PI);
        // 关闭一个路径。会连接起点和终点。如果关闭路径后没有调用 fill 或者 stroke 并开启了新的路径，那之前的路径将不会被渲染
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.clip();
        // 水波纹渐变色

        grd = ctx.createRadialGradient(bollArg.O.x, bollArg.O.y, bollArg.R, bollArg.O.x, bollArg.O.y, bollArg.R);
        grd.addColorStop(0, bollArg.waveStyle.fillColor.end); // 圆心颜色
        grd.addColorStop(1, bollArg.waveStyle.fillColor.start); // 边缘颜色
        ctx.fillStyle = grd;

        ctx.beginPath();
        ctx.strokeStyle = bollArg.waveStyle.strokeColor;
        ctx.fillStyle = grd;
        ctx.moveTo(bollArg.O.x - bollArg.R, bollArg.O.y + bollArg.R + bollArg.A);
        for (angle = bollArg.O.x - bollArg.R; angle < bollArg.O.x + bollArg.R + bollArg.angleStep; angle +=
          bollArg.angleStep) {
          y = bollArg.A * Math.sin(this.bollStep / bollArg.vs + angle / bollArg.waveLen * Math.PI * 2);
          x = angle;
          ctx.lineTo(x, (y + bollArg.R * 2 + bollArg.A + grid.top) - part * 0.01 * (bollArg.R * 2 *
            (bollArg.waveHeight + 1) / 100));

        }
        ctx.lineTo(bollArg.O.x + bollArg.R, bollArg.O.y + bollArg.R + bollArg.A);
        ctx.fill();
        ctx.restore();

        ctx.beginPath();
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = bollArg.textStyle.fillColor;
        ctx.font = "24px Source Han Sans CN";
        ctx.fillText(this.toFixedNumber(0, bollArg.waveHeight * 0.01 * part) + "%", bollArg.O.x, bollArg.O
          .y);

        ctx.font = "14px Source Han Sans CN";
        ctx.fillText("领取" + _this.rewardAmount + '元', bollArg.O.x, bollArg.O.y + 25);
        ctx.save();
        ctx.restore();

        ctx.fill();
        // ctx.draw();

        part++;
        if (part >= 100) {
          part = 100;
        }

        this.bollStep++;
        if (this.bollStep > 2012) {
          this.bollStep = 0;
        }
        this.bollTimeR = requestAnimationFrame(drawBoll);
      }
      //  window.requestAnimationFrame(drawBoll);
      drawBoll();
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-dialog {
  width: 330px !important;
  background: none !important
}

::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-dialog--center .el-dialog__body {
  padding: 0;
}

::v-deep .el-dialog__body {
  padding: 0;
}

.mar-bot20 {
  cursor: pointer;
}

.step {
  display: flex;
  flex-direction: column;
  width: 330px;
  height: 312px;
  background: url("./img/bg.png");
  background-size: contain;
  border-radius: 20px;
  margin: 0 auto;
}

.step-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
  height: 40px;

  .title-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 40px;
    background: linear-gradient(270deg, rgba(217, 185, 142, 0.00) 0%, #D9B98E 50.08%, rgba(217, 185, 142, 0.00) 100%);
    opacity: 0.2;
  }

  .img-box {
    position: absolute;
    left: 16px;
  }

  .back-btn {
    width: 20px;
    height: 20px;
  }

  .title-text {
    font-size: 16px;
    text-align: center;
    font-weight: 700;
    color: #D9B98E;
    font-family: Source Han Sans CN;
    text-transform: uppercase;
  }
}

.line {
  width: 100%;
  height: 1px;
  opacity: 0.6;
  background: linear-gradient(270deg, rgba(217, 185, 142, 0.00) 0%, #D9B98E 50.08%, rgba(217, 185, 142, 0.00) 100%);
}

.text {
  flex: 1;
  text-align: center;
  font-size: 22px;
  color: rgba(112, 112, 112, 1);
  font-weight: 500;
  font-family: PingFang SC;
}

.img {
  width: 50px;
  height: 50px;
}

.step-list {
  // padding: 20px;
  box-sizing: border-box;
  flex: 1;
  overflow-y: auto;
  padding: 0 20px;
  margin-bottom: 20px;
}

.step-item {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.btn {
  width: 72px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 12px;
  border-radius: 180px;
  margin-left: 16px;
  color: #4D381B;
  background: linear-gradient(0deg, #C08B43 0%, #F2E8D9 100%);

}

.img-list {
  text-align: center;
  padding: 26px 24px;
  font-size: 12px;
  color: #F2E8D9;
  line-height: 16px;
  overflow-y: auto;
}

.received {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 72px;
  border-radius: 15px;
  opacity: 0.9;
  background: rgba(0, 0, 0, 0.90);
  text-align: center;

  .img-success {
    width: 24px;
    height: 24px;
  }

  .text-success {
    margin-top: 12px;
    color: #F2E8D9;
    font-size: 12px;
    font-weight: 500;
    font-family: Source Han Sans CN;
  }
}




.click-me {
  font-size: 14px;
  color: rgba(112, 112, 112, 1);
  font-weight: 500;
  font-family: PingFang SC;
}

.btn-auto {
  width: 120px;
  height: 40px;
  margin: 20px auto;
}

.usdt-icon {
  width: 146px;
  height: 120px;
  overflow: hidden;
}

.progress {
  position: absolute;
  bottom: 0;
  left: 31px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 60px;
  border: 1.8px solid #FFE29E;
  background: linear-gradient(180deg, #00AE7F 0%, #007746 100%);
  box-shadow: 2px 3px 0px 0px rgba(0, 0, 0, 0.14) inset;
}

.progress-text {
  position: absolute;
  width: 88px;
  bottom: 0;
  left: 31px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #003E24;
  font-size: 14px;
  font-weight: 600;
}

.progress-text-finish {
  color: #FFE29E !important
}

.usdt-img-head {
  position: absolute;
  height: 104px;
  top: -103px;
  left: 50%;
  transform: translateX(-50%);
}

.close {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 32px;
  height: 32px;
  bottom: -40px;
}
</style>
